export var JobStepStatus;
(function (JobStepStatus) {
    JobStepStatus["JOB_STEP_STATUS_UNSPECIFIED"] = "JOB_STEP_STATUS_UNSPECIFIED";
    JobStepStatus["JOB_STEP_STATUS_PENDING"] = "PENDING";
    JobStepStatus["JOB_STEP_STATUS_RUNNING"] = "RUNNING";
    JobStepStatus["JOB_STEP_STATUS_COMPLETED"] = "COMPLETED";
    JobStepStatus["JOB_STEP_STATUS_FAILED"] = "FAILED";
})(JobStepStatus || (JobStepStatus = {}));
